import { useContext, useEffect } from 'react';

import { useOptimove } from '@/common/hooks/useOptimove/useOptimove';
import { AuthContext } from '@/contexts/auth/AuthContext';

const useOptimoveSetLoggedUser = () => {
  const { fetchedUserInfo, userInfo } = useContext(AuthContext);
  const { optimoveSDKInitialized } = useOptimove();

  useEffect(() => {
    if (optimoveSDKInitialized && fetchedUserInfo && userInfo?.isUserLoggedIn) {
      window.optimoveSDK.API.reportEvent('sign_in', {
        is_subscriber: userInfo.subscriptionActive,
      });
    }
  }, [optimoveSDKInitialized, fetchedUserInfo, userInfo]);
};

export default useOptimoveSetLoggedUser;
